import WebGalleryVideoAlbumNullState from './WebGalleryVideoAlbumNullState';

export default WebGalleryVideoAlbumNullState;
